import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { adminApi } from '@/data/api/adminApi';
const USR = 'admin-usuarios';
const GRP = 'admin-grupos';
const PER = 'admin-permisos';
export function useUsuariosAdmin(filtros) {
    return useQuery({
        queryKey: [USR, filtros],
        queryFn: () => adminApi.listarUsuarios(filtros),
        placeholderData: (p) => p,
    });
}
export function useCrearUsuario() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (v) => adminApi.crearUsuario(v),
        onSuccess: () => qc.invalidateQueries({ queryKey: [USR] }),
    });
}
export function useEditarUsuario() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, values }) => adminApi.editarUsuario(id, values),
        onSuccess: () => qc.invalidateQueries({ queryKey: [USR] }),
    });
}
export function useCambiarEstadoUsuario() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, activo }) => adminApi.cambiarEstadoUsuario(id, activo),
        onSuccess: () => qc.invalidateQueries({ queryKey: [USR] }),
    });
}
export function useGruposAdmin() {
    return useQuery({
        queryKey: [GRP],
        queryFn: () => adminApi.listarGrupos(),
    });
}
export function useCrearGrupo() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (v) => adminApi.crearGrupo(v),
        onSuccess: () => qc.invalidateQueries({ queryKey: [GRP] }),
    });
}
export function useEditarGrupo() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, values }) => adminApi.editarGrupo(id, values),
        onSuccess: () => qc.invalidateQueries({ queryKey: [GRP] }),
    });
}
export function useDesactivarGrupo() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => adminApi.desactivarGrupo(id),
        onSuccess: () => qc.invalidateQueries({ queryKey: [GRP] }),
    });
}
export function usePermisos() {
    return useQuery({
        queryKey: [PER],
        queryFn: () => adminApi.listarPermisos(),
        staleTime: 5 * 60_000,
    });
}
